import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';
import { useCurrentUser } from '@bonusly/who-am-i';

import { EventAPIData, MeetingAPIData, UserAPIData } from '../../../types/growth-api';
import { QueryKey } from '../../../types/growth-query-key';
import { EventDTO } from '../lib/entities/event';
import { MeetingDTO } from '../lib/entities/meeting';
import { UserDTO } from '../lib/entities/user';

export const useCurrentOneOnOneWithReport = (reportId: string) => {
	const http = useHttpClient();
	const user = useCurrentUser();
	const queryClient = useQueryClient();

	return useQuery({
		queryKey: [QueryKey.CurrentOneOnOne, reportId],
		queryFn: async () => {
			const eventsRes = await http.get<EventAPIData[]>('/one_on_ones/events', {
				params: {
					guest_id: reportId,
					status: 'active',
				},
			});

			const eventData = eventsRes.data.find((e) => e.host_id === user.id);

			if (!eventData) {
				return null;
			}

			const event = new EventDTO(eventData);

			const usersRes = await http.get<UserAPIData[]>('user_management/users', {
				params: {
					user_ids: [event.hostId, event.guestId],
				},
			});

			const users = usersRes.data.map((user) => new UserDTO(user));
			event.host = users.find((user) => user.id === event.hostId);
			event.guest = users.find((user) => user.id === event.guestId);

			const meetingRes = await http.get<MeetingAPIData>(`/one_on_ones/events/${event.id}/meetings/current`);
			const meeting = new MeetingDTO(meetingRes.data);
			meeting.event = event;

			queryClient.setQueryData([QueryKey.Event, event.id], event);
			queryClient.setQueryData([QueryKey.Meeting, meeting.id], meeting);

			return meeting;
		},
	});
};
